import { render, staticRenderFns } from "./laborDetail.vue?vue&type=template&id=464912cd&"
import script from "./laborDetail.vue?vue&type=script&lang=js&"
export * from "./laborDetail.vue?vue&type=script&lang=js&"
import style0 from "./laborDetail.vue?vue&type=style&index=0&id=464912cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports